import { ModuleWithProviders} from '@angular/core';
import {Routes, RouterModule } from '@angular/router';

import { ScheduleTelevisitListComponent } from './schedule-televisit-list.component'

const SCHEDULE_TELEVISIT_LIST_ROUTES: Routes = [{
    path: '', component: ScheduleTelevisitListComponent
}];

export const SCHEDULE_TELEVISIT_LIST_ROUTING  = RouterModule.forChild(SCHEDULE_TELEVISIT_LIST_ROUTES);